/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Editor_WebglInputs */

const en_gc_editor_webgl = /** @type {(inputs: Gc_Editor_WebglInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open with WebGL`)
};

const zh_gc_editor_webgl = /** @type {(inputs: Gc_Editor_WebglInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使用 WebGL 打开`)
};

/**
* | output |
* | --- |
* | "Open with WebGL" |
*
* @param {Gc_Editor_WebglInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_editor_webgl = /** @type {((inputs?: Gc_Editor_WebglInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Editor_WebglInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_editor_webgl(inputs)
	return zh_gc_editor_webgl(inputs)
});
export { gc_editor_webgl as "gc.editor.webgl" }